// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1X_un","clinicsSelect":"styles_clinicsSelect__QWicA"};